import { AsyncPipe, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { FormValue } from '../../../entities/form-value.entity';
import { ShFormDateComplexBaseComponent } from '../base-complex/form-date-complex-base.component';

@Component({
    selector: 'sh-form-date-base',
    templateUrl: '../base-complex/form-date-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormDateBaseComponent)],
    standalone: true,
    imports: [ReactiveFormsModule, AsyncPipe]
})
export class ShFormDateBaseComponent extends ShFormDateComplexBaseComponent {
    constructor(
        changeDetectorRef: ChangeDetectorRef,
        protected datePipe: DatePipe
    ) {
        super(changeDetectorRef, datePipe);
    }

    propagateChange(fv: FormValue<string | null>): void {
        super.propagateSimpleChange(FormValue.unwrap(fv));
    }

    writeValue(obj: any): void {
        super.writeValue(FormValue.wrap(obj));
    }
}
